import React from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../../../util/cookie/cookies";

export const AboutOverView = () => {
    const lang = getCookie('HYUNDAILANG')
    const {t} = useTranslation()
    return(
        <>
        <div className="contentBox">
            <div>
                <div className="left">
                    <img src="/assets/images/companyOverview.png" alt="회사개요"/>
                </div>
                <div className="right">
                    {lang === 'kr' ? 
                    <h3>
                        <span>현대엔테크를 응원해 주신 여러분께 항상<br/>
                        감사드리며,</span> 여러분의 기대에 부응할 수 있도록
                        진심을 다해 노력하겠습니다.  
                    </h3>
                    :
                    <h3>Thank you always for supporting Hyundai NTech,<br/> and we will do our best to meet your expectations.</h3>
                    }
                    <p>
                        {t("about_overview_1")}
                    </p>
                    <p>
                    {t("about_overview_2")}
                    </p>
                    <p>
                    {t("about_overview_3")}
                    </p>
                    <p>
                    {t("about_overview_4")}
                    </p>
                    <p>
                    {t("about_overview_5")}
                    </p>
                    <p>{t("about_overview_6")}</p>
                    <span>
                    {t("about_overview_7")} <span>{t("about_overview_8")}</span>
                    </span>
                </div>
            </div>
        </div>
        </>
    )
}